import React from "react";
import {
  MdAccountBalance,
  MdTrendingUp,
  MdSavings,
  MdAccountBalanceWallet,
} from "react-icons/md";
import { HiChartBar, HiDocumentText } from "react-icons/hi2";
import "../styles/Pages.css";

const BankPage = ({ user, accounts }) => {
  const bankingServices = [
    {
      id: "savings",
      icon: <MdSavings />,
      title: "Savings Account",
      description: "Earn competitive interest on your savings",
      rate: "5.25% p.a.",
      features: ["No monthly fees", "Instant access", "Auto-save options"],
    },
    {
      id: "fixed",
      icon: <MdTrendingUp />,
      title: "Fixed Deposit",
      description: "Lock in great rates for guaranteed returns",
      rate: "Up to 8.5% p.a.",
      features: [
        "Terms from 1-60 months",
        "Competitive rates",
        "Secure investment",
      ],
    },
    {
      id: "current",
      icon: <MdAccountBalance />,
      title: "Current Account",
      description: "Everyday banking made easy",
      rate: "Free banking",
      features: [
        "Unlimited transactions",
        "Overdraft facility",
        "Debit card included",
      ],
    },
    {
      id: "wealth",
      icon: <MdAccountBalanceWallet />,
      title: "Wealth Management",
      description: "Professional portfolio management",
      rate: "Bespoke solutions",
      features: ["Dedicated advisor", "Custom strategies", "Regular reviews"],
    },
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Banking Services</h1>
        <p className="page-subtitle">
          Manage your accounts and explore banking solutions
        </p>
      </div>

      <div className="services-grid">
        {bankingServices.map((service) => (
          <div key={service.id} className="service-card">
            <div className="service-icon">{service.icon}</div>
            <div className="service-content">
              <h3>{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <div className="service-rate">{service.rate}</div>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>
                    <HiChartBar className="feature-check" />
                    {feature}
                  </li>
                ))}
              </ul>
              <button className="btn-outline">Learn More</button>
            </div>
          </div>
        ))}
      </div>

      <div className="documents-section">
        <h3>
          <HiDocumentText /> Banking Documents
        </h3>
        <div className="documents-grid">
          <button className="document-item">
            <HiDocumentText />
            <span>Account Statements</span>
          </button>
          <button className="document-item">
            <HiDocumentText />
            <span>Tax Certificates</span>
          </button>
          <button className="document-item">
            <HiDocumentText />
            <span>Terms & Conditions</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BankPage;
